import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRole, fetchBranchDetails, fetchDepartmentDetails, fetchGroupDetails, fetchRoleDetails, fetcTypeAndSpecializationDetails,fetchDesignationDetails, fetchReportingManagerDetails, fetchReportingRolesDetails } from '../../services/user/RolesService';

export const fetchDepartmentDetailsAsync = createAsyncThunk(
    'user/fetchGroupDetails',
    async ( thunkAPI) => {
        const response = await fetchDepartmentDetails();
        return response;
    }
);

export const fetchGroupsDetailsAsync = createAsyncThunk(
    'user/fetchRoleDetails',
    async (departmentId: string, thunkAPI) => {
        const response = await fetchGroupDetails(departmentId);
        return response;
    }
);

export const fetchRolesDetailsAsync = createAsyncThunk(
    'user/fetchDepartmentDetails',
    async (groupId: string, thunkAPI) => {
        const response = await fetchRoleDetails(groupId);
        return response;
    }
);

export const fetchTypeAndSpecializationDetailsAsync = createAsyncThunk(
    'user/fetcTypeAndSpecializationDetails',
    async (roleId: string, thunkAPI) => {
        const response = await fetcTypeAndSpecializationDetails(roleId);
        return response;
    }
);

export const createRoleAsync = createAsyncThunk(
    'user/createRole',
    async (data: any, thunkAPI) => { 
      const response = await createRole(data);
      return response;
    }
  );

  export const fetchBranchDetailsAsync = createAsyncThunk(
    'user/fetchBranchDetails',
    async ( thunkAPI) => {
        const response = await fetchBranchDetails();
        return response;
    }
);

export const fetchDesignationDetailsAsync = createAsyncThunk(
    'user/fetchDesignationDetails',
    async (roleId: string, thunkAPI) => {
        const response = await fetchDesignationDetails(roleId);
        return response;
    }
);

export const fetchReportingManagerDetailsAsync = createAsyncThunk(
    'user/fetchReportingManagerDetails',
    async (roleID: string, thunkAPI) => {
        const response = await fetchReportingManagerDetails(roleID);
        return response;
    }
);

export const fetchReportingRoleDetailsAsync = createAsyncThunk(
    'user/fetchReportingRolesDetails',
    async (roleID: string, thunkAPI) => {
        const response = await fetchReportingRolesDetails(roleID);
        return response;
    }
);